import { getApplicationHost } from 'src/data/system';
import { formatRoute, type RouteParams } from 'src/lib/routing';
import { preparePlatformUrl } from 'src/lib/url';
import { type Route, ROUTE_PARAMS, ROUTES } from 'src/routes';

const formatExternalPlatformLink = (route: Route, params?: RouteParams): string => {
  const mergedParams = params ? { ...params } : {};

  const host = getApplicationHost();
  if (host) {
    mergedParams[ROUTE_PARAMS.host] = host;
  }

  const path = formatRoute(route, mergedParams);
  return preparePlatformUrl(path);
};

export const formatUpgradeLink = (): string => formatExternalPlatformLink(ROUTES.UPGRADE);

export const formatAbsoluteRootLink = (): string => formatExternalPlatformLink(ROUTES.ROOT);
